import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import Workspace from '../../entities/workspace';
import useMembersUsagePresenter from '../../presenters/MembersUsagePresenter/useMembersUsagePresenter';
import MembersUsage from '../../components/subscription/MembersUsage/MembersUsage';
import Button from '../../new_arch/components/Button/Button';

const MembersUsageContainer = ( {
	workspace, inviteMemberButton, onPaidFeatureModalAcceptClick, canAddAddOns
} ) => {
	const presenter = useMembersUsagePresenter( { workspace, onPaidFeatureModalAcceptClick } );
	const onAddOnsButtonClick = canAddAddOns ? presenter.addOnsButtonWasClicked : presenter.alertOfPaidFeature;
	return (
		<MembersUsage
			presenter={presenter}
			inviteMemberButton={inviteMemberButton}
			onAddOnsButtonClick={onAddOnsButtonClick}
		/>
	);
};

MembersUsageContainer.propTypes = {
	workspace: PropTypes.instanceOf( Workspace ).isRequired,
	inviteMemberButton: PropTypes.instanceOf( Button ),
	onPaidFeatureModalAcceptClick: PropTypes.func.isRequired,
	canAddAddOns: PropTypes.bool
};

MembersUsageContainer.defaultProps = {
	inviteMemberButton: undefined,
	canAddAddOns: true
};

export default observer( MembersUsageContainer );
